/**
 * ONCE PER PAGE: a promise per key, made on the first ask and shared by
 * every later one, kept across client navigation. A failed one is dropped,
 * so the next ask tries again. No framework, no three.js.
 */
export function once<T>(
  kept: Map<string, Promise<T>>,
  key: string,
  make: () => Promise<T>,
): Promise<T> {
  let made = kept.get(key);
  if (!made) {
    made = make();
    made.catch(() => {
      if (kept.get(key) === made) kept.delete(key);
    });
    kept.set(key, made);
  }
  return made;
}
